import React from "react";
import PublicOCDS from "../../Admin/OCDS/PublicOCDS";
// import OcdsPublic from "../../Admin/OCDS";
import withHeaderFooterHOC from "../HOC/withHeaderFooterHOC";

const PageContent = () => <PublicOCDS isPublic={true} />;
export default withHeaderFooterHOC(PageContent);
